import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { implementationExample } from './snippets/implementationExample';
import { requestBodyExample } from './snippets/requestBodyExample';
import { responseOkExample } from './snippets/responseOkExample';

import { CodeSnippet } from '@/components/CodeSnippet';
import { Button } from '@/components/ui/Button';
import { ROUTE_PATHS } from '@/config/constants';
import { useAuth } from '@/contexts/AuthContext';

export function SearchIntegrationGuide() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Personalization.components.SearchImplementationGuide',
  });
  const { user } = useAuth();

  const navigate = useNavigate();

  function handleGenerateToken() {
    if (user?.customer.freemium) {
      toast.error(t('freemiumErrorMessage'));
      return;
    }

    navigate(`${ROUTE_PATHS.SETTINGS}?tab=app-tokens`);
  }

  return (
    <div className="border-t border-gray-200 bg-gray-50 p-6">
      <div className="mt-6 rounded-lg border bg-white p-6 shadow-sm">
        <div className="mb-6">
          <h4 className="text-md mb-2 font-medium">Endpoint</h4>
          <div className="text-md rounded-md bg-gray-800 p-4 text-white">
            POST
            https://catalog.api.fashionai.dev/api/v1/products/protected/search
          </div>
        </div>

        <div className="mb-6">
          <div className="mt-4 grid grid-cols-1 gap-6 md:grid-cols-2">
            <div className="rounded-lg border border-gray-200 p-4">
              <h5 className="mb-2 font-medium">Request Headers</h5>
              <div className="flex flex-col gap-2 rounded-md bg-gray-50 p-3 font-mono text-sm">
                <span>Content-Type: application/json</span>
                <span>X-FashionAI-APP-Token: {'<your_app_token>'}</span>
              </div>
            </div>
          </div>

          <div className="mt-4 grid grid-cols-1 gap-6 md:grid-cols-2">
            <div className="rounded-lg border border-gray-200 p-4">
              <h5 className="mb-2 font-medium">Request Params</h5>
              <div className="flex flex-col gap-2 rounded-md bg-gray-50 p-3 font-mono text-sm">
                <span>page: 1</span>
                <span>limit: 10</span>
                <span>query: camisas pretas</span>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <Button variant="outline" onClick={handleGenerateToken}>
              {t('generateTokenButton')}
            </Button>
          </div>
        </div>

        <div className="mb-6">
          <h4 className="text-md mb-2 font-medium">Request Body</h4>
          <div className="text-md">
            <CodeSnippet
              language="javascript"
              codeString={requestBodyExample}
            />
          </div>
        </div>

        <div className="mb-6">
          <h4 className="text-md mb-2 font-medium">Response</h4>
          <div className="text-md">
            <CodeSnippet language="javascript" codeString={responseOkExample} />
          </div>
        </div>

        <div className="mb-6">
          <h4 className="text-md mb-2 font-medium">
            Implementation JavaScript/TypeScript
          </h4>
          <div className="text-md">
            <CodeSnippet
              language="javascript"
              codeString={implementationExample}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
